export enum ContentType {
  JPEG = 'image/jpeg',
  OCTET_STREAM = 'application/octet-stream',
  PNG = 'image/png',
  PDF = 'application/pdf',
  PLAIN_TEXT = 'text/plain',
  ZIP = 'application/zip'
}

export enum ProposalRisk {
  DENIED = 'denied',
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  VERY_LOW = 'veryLow'
}

export enum FinancialService {
  BMP = 'bmp',
  FIDUCIA = 'fiducia',
  PARATI = 'parati',
  WORK_SCD = 'workScd'
}

export enum IdWallQueueStatus {
  IDLE = 'idle',
  PROCESSING = 'processing',
  DONE = 'done',
  BLOCKED = 'blocked',
  ERROR = 'error'
}

export enum AccountRejectionType {
  INVALID_CPF = 'INVALID_CPF',
  MISSING_DATA = 'MISSING_DATA',
  DEAD = 'DEAD',
  USER_IS_YOUNG = 'USER_IS_YOUNG',
  CPF_DATA_NOT_FOUND = 'CPF_DATA_NOT_FOUND'
}

export enum PersonType {
  PF = 'PF',
  PJ = 'PJ'
}

export enum AwsEventType {
  s3 = 's3',
  apiGatewayAwsProxy = 'apiGatewayAwsProxy',
  cloudFrontRequestEvent = 'cloudFrontRequestEvent',
  sqsEvent = 'sqsEvent',
  other = 'other'
}

export enum UserType {
  borrower = 'borrower',
  investor = 'investor'
}

export enum Gender {
  woman = 'woman',
  man = 'man',
  womanTransexual = 'womanTransexual',
  manTransexual = 'manTransexual',
  nonBinary = 'nonBinary',
  others = 'others'
}

export enum Sex {
  male = 'M',
  female = 'F',
  other = 'O'
}

export enum AccountStatus {
  pendingPhoneVerification = 'pendingPhoneVerification',
  pendingData = 'pendingData',
  pendingIugu = 'pendingIugu',
  pendingBackOffice = 'pendingBackOffice',
  fraudAnalysis = 'fraudAnalysis',
  fraudSuspect = 'fraudSuspect',
  approved = 'approved',
  noLimit = 'noLimit',
  fraud = 'fraud'
}

export enum PendencyStatus {
  pending = 'pending',
  loading = 'loading',
  solved = 'solved',
  analysis = 'analysis',
  approved = 'approved',
  rejected = 'rejected'
}

export enum ReportStatus {
  processing = 'processing',
  analysis = 'analysis',
  approved = 'approved',
  reproved = 'reproved'
}

export enum TestABValue {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export enum RejectionPendencyTarget {
  address = 'address',
  addressProof = 'addressProof',
  entireAddressFlow = 'entireAddressFlow',
  selfie = 'selfie',
  idDocuments = 'idDocuments',
  entireIdFlow = 'entireIdFlow'
}

export enum RejectionFlow {
  address = 'address',
  id = 'id'
}

export enum ReportType {
  IDWALL = 'idwall',
  CAF = 'caf'
}

export enum MaritalStatus {
  single = 'single',
  totalUnionMarriage = 'totalUnionMarriage',
  partialUnionMarriage = 'partialMarriage',
  totalSeparationMarriage = 'totalSeparationMarriage',
  widower = 'widower'
}

export enum AccountRole {
  user = 'user',
  creditPartnerAdmin = 'creditPartnerAdmin',
  creditPartnerAnalyst = 'creditPartnerAnalyst',
  admin = 'admin',
  dev = 'dev',
  analyst = 'analyst',
  creditAnalyst = 'creditAnalyst'
}

export enum IdDocumentType {
  rg = 'rg',
  cnh = 'cnh'
}

export enum CompanyPartnerType {
  MANAGING_PARTNER = 'managingPartner',
  PARTNER = 'partner'
}

export enum AccountLock {
  CREATE_IUGU_ACCOUNT = 'createIuguAccount',
  CREATE_BMP_ACCOUNT = 'createBMPAccount',
  SEND_TO_FRAUD_ANALYSIS = 'sendToFraudAnalsysis',
  CHECK_ADDRESS_SCORE = 'checkAddressScore'
}

export enum PJDocumentType {
  PARTNER_DOCUMENT_ID = 'partnerDocumentId',
  SOCIAL_CONTRACT = 'socialContract',
  OTHER = 'other'
}

export enum AccountAnalysisStatus {
  INITIAL_ANALYSIS = 'initialAnalysis',
  ANALYST_QUEUE = 'analystQueue',
  PENDING_ALL_DOCUMENTATION = 'pendingAllDocumentation',
  PENDING_COMPLETE_DATA = 'pendingCompleteData',
  DOCUMENTATION_WITH_PENDENCIES = 'documentationWithPendencies',
  DOCUMENTATION_PARTIALLY_PENDING = 'documentationPartiallyPending',
  WAITING_FOR_ANALYSIS = 'waitingForAnalysis',
  WAITING_FOR_ANALYSIS_POST_PENDENCIES = 'waitingForAnalysisPostPendencies',
  DENIED = 'denied',
  UNDER_ANALYSIS = 'underAnalysis',
  DENIED_POST_ANALYSIS = 'deniedPostAnalysis',
  PRE_APPROVED = 'preApproved',
  GAVE_UP_POST_INITIAL_ANALYSIS = 'gaveUpPostInitialAnalysis',
  COMMITTEE = 'committee',
  APPROVED = 'approved',
  ACCEPTED = 'accepted',
  COMPLETED = 'completed'
}

export enum AccountDenialReason {
  BLACKLIST = 'blacklist',
  INACTIVE_CNPJ = 'inactiveCNPJ',
  IS_MEI = 'isMei',
  NEW_COMPANY = 'newCompany',
  LEGAL_NATURE = 'legalNature',
  CNAE = 'CNAE',
  LOW_BILLING = 'lowBilling',
  PJ_PROTESTS = 'pjProtests',
  SCR_PJ = 'scrPJ',
  SCR_BILLING = 'scrBilling',
  PF_PROTESTS = 'pfProtests',
  SCR_PF = 'scrPF',
  CPF_NOT_REGULAR = 'cpfNotRegular',
  FRAUD_INDICATOR = 'fraudIndicator',
  PJ_LAWSUITS = 'pjLawsuits',
  PF_LAWSUITS = 'pfLawsuits',
  SCORE_PF = 'scorePF',
  SERASA_RESTRICTIONS_SUM = 'serasaRestrictionsSum',
  SERASA_BINARY_RESTRICTIONS = 'serasaBinaryRestrictions',
  SERASA_HPJ4_SCORE = 'serasaHpj4Score',
  QUANTITATIVE_SCORE = 'quantitativeScore',
  SERASA_SCORES_RATIO = 'serasaScoresRatio'
}

export enum SmallBusinessType {
  SMALL_BUSINESS_OWNER = 'SMALL_BUSINESS_OWNER', // Dono de pequeno negocio
  DRIVER = 'DRIVER', // Motorista de aplicativo
  DIARIST = 'DIARIST', // diarista
  HAIR_CUTTER = 'HAIR_CUTTER', // cabeleleiro
  HAND_CARE = 'HAND_CARE', // manicure
  HAWKER = 'HAWKER', // vendedor ambulante
  FOOD_TRUCK = 'FOOD_TRUCK', // dono de food truck
  REFORMS_AND_REPAIRS = 'REFORMS_AND_REPAIRS', // Profissional de reformas e reparos
  TAILOR = 'TAILOR', // Costureira/Alfaiate
  CAREGIVER = 'CAREGIVER', // Cuidador
  MECHANIC = 'MECHANIC', // Mecanico
  PRIVATE_TUTOR = 'PRIVATE_TUTOR', // Professor particular
  CAR_KEEPER = 'CAR_KEEPER', // Lavador/guardador de carros
  PARTY_SERVICES = 'PARTY_SERVICES', // Buffet e serviços para festa
  BROKER = 'BROKER', // BROKER
  TOURISM = 'TOURISM', // Agente de turismo
  OTHER = 'OTHER' // outro
}

export enum TempProfilePictureType {
  TEMP = 'temp',
  DEFINITIVE = 'definitive'
}

export enum PictureType {
  TEMP = 'temp',
  DEFINITIVE = 'definitive'
}

export enum AddressProofDocumentType {
  light = 'light',
  water = 'water',
  phone = 'phone',
  tv = 'tv',
  healthInsurance = 'healthInsurance',
  creditCard = 'creditCard',
  unknown = 'unknown'
}

export enum AddressProofOwnerType {
  self = 'self',
  mother = 'mother',
  father = 'father'
}

export enum ObservationType {
  address = 'address',
  idDocuments = 'idDocuments'
}

export enum ObservationResult {
  approved = 'approved',
  rejected = 'rejected'
}

export enum AccountConversion {
  firstSimulatedAt = 'firstSimulatedAt',
  firstHadLimitAt = 'firstHadLimitAt',
  firstRequestedLoanAt = 'firstRequestedLoanAt',
  firstPublishedLoanAt = 'firstPublishedLoanAt',
  firstInvestedAt = 'firstInvestedAt',
  firstSentPendencyAt = 'firstSentPendencyAt',
  firstWalletPaymentAt = 'firstWalletPaymentAt',
  firstWalletInvoiceGeneratedAt = 'firstWalletInvoiceGeneratedAt',
  firstSentAllPendenciesAt = 'firstSentAllPendenciesAt',
  validatedPhoneAt = 'validatedPhoneAt',
  firstQuestionsAnsweredAt = 'firstQuestionsAnsweredAt'
}

export enum AccountPageFlag {
  hasSimulatedLoan = 'hasSimulatedLoan',
  hasBeingPaidLoan = 'hasBeingPaidLoan',
  hasPublishedLoan = 'hasPublishedLoan',
  hasExpiredLoan = 'hasExpiredLoan',
  hasRequestedLoan = 'hasRequestedLoan'
}

export enum AccountFlag {
  changedProfilePicture = 'changedProfilePicture',
  hasInvestment = 'hasInvestment',
  hasActiveLoan = 'hasActiveLoan',
  hasLimit = 'hasLimit',
  hasSimulated = 'hasSimulated',
  hasActivatedAutomaticInvestment = 'hasActivatedAutomaticInvestment',
  hasToUpdateSuitability = 'hasToUpdateSuitability',
  hasLoanBeingPaid = 'hasLoanBeingPaid',
  isSmallBusiness = 'isSmallBusiness',
  shouldShowInvestorFirstTutorial = 'shouldShowInvestorFirstTutorial',
  shouldShowInvestorAutomaticInvestmentTutorial = 'shouldShowInvestorAutomaticInvestmentTutorial',
  hasPublishedLoan = 'hasPublishedLoan',
  hasExpiredLoan = 'hasExpiredLoan',
  hasRequestedLoan = 'hasRequestedLoan',
  hasSimulatedLoan = 'hasSimulatedLoan',
  ban0 = 'ban0',
  showSmallBusinessInitiativeTutorial = 'showSmallBusinessInitiativeTutorial',
  hasAnswered = 'hasAnswered',
  blockAccessAppBorrower = 'blockAccessAppBorrower',
  blockAccessAppInvestor = 'blockAccessAppInvestor',
  enableNewDashboardInvestor = 'enableNewDashboardInvestor'
}

export enum UpdatableExternalAccountFlag {
  shouldShowInvestorFirstTutorial = 'shouldShowInvestorFirstTutorial',
  showSmallBusinessInitiativeTutorial = 'showSmallBusinessInitiativeTutorial'
}

export enum S3UploadType {
  cnhFront = 'cnhFront',
  cnhBack = 'cnhBack',
  rgFront = 'rgFront',
  rgBack = 'rgBack',
  selfie = 'selfie',
  addressProof = 'addressProof',
  profilePicture = 'profilePicture',
  tempProfilePicture = 'tempProfilePicture',
  companyAddressProof = 'companyAddressProof',
  companySocialContract = 'companySocialContract',
  companySocialContractChange = 'companySocialContractChange',
  companyPartnerAddressProof = 'companyPartnerAddressProof',
  companyPartnerIdFront = 'companyPartnerIdFront',
  companyPartnerIdBack = 'companyPartnerIdBack',
  pjDocument = 'pjDocument',
  pjProfilePicture = 'pjProfilePicture',
  pjBackgroundPicture = 'pjBackgroundPicture',
  bankStatementLastMonth = 'bankStatementLastMonth',
  bankStatementTwoMonthsAgo = 'bankStatementTwoMonthsAgo',
  bankStatementThreeMonthsAgo = 'bankStatementThreeMonthsAgo'
}

export enum IdWallHookEventType {
  statusChange = 'protocolo_status'
}

export enum IdWallReportStatus {
  pending = 'PENDENTE', // Esperando para processar
  analysis = 'EM ANALISE', // Em analise do lado deles (houve algum erro no lado deles)
  preProcessing = 'PRE-PROCESSANDO', // Pre processamento
  processing = 'PROCESSANDO', // Em processamento
  concluded = 'CONCLUIDO' // Concluido
}

export enum IdWallReportResult {
  valid = 'VALID', // Aprovado automaticamente
  invalid = 'INVALID', // Precisa de inspeção manual
  manualReproval = 'MANUAL_REPROVAL', // Reprovado manualmente
  manualApproval = 'MANUAL_APPROVAL' // Aprovado manualmente
}

export enum IdWallReportValidationRuleType {
  situacaoReceitaFederal = 'idwall.matrix.regras.cpf.RegraSituacaoReceitaFederal', // situação cadastral regular
  obito = 'idwall.matrix.regras.cpf.RegraObito', // Não deve constar obito
  dataNascimento = 'idwall.matrix.regras.cpf.RegraDataNascimento', // Data de nascimento igual ao da receita federal
  nomeReceitaFederal = 'idwall.matrix.regras.cpf.RegraFuzzyNomeReceitaFederal', // Nome deve ser semelhante ao da receita federal
  validacaoDocumentos = 'idwall.matrix.regras.RegraValidacaoDocumentos' // imagens processadas com sucesso
}

export enum IdWallReportType {
  cnh = 'cnh',
  rg = 'rg'
}

export enum PropertyType {
  rented = 'rented',
  own = 'own'
}

export const BankAccountType = {
  corrente: 'cc',
  poupanca: 'cp'
} as const
export type BankAccountType = typeof BankAccountType[keyof typeof BankAccountType]

export enum PhoneValidationCodeChannel {
  WHATSAPP = 'whatsapp',
  SMS = 'sms',
  PARTNER = 'partner'
}

export enum ValidationCodeChannel {
  WHATSAPP = 'whatsapp',
  SMS = 'sms',
  EMAIL = 'email'
}

export enum ReasonGenerateValidationCode {
  REGISTER_PHONE_VALIDATION = 'phoneValidation',
  REGISTER_EMAIL_VALIDATION = 'emailValidation',
  RECOVER_FORGOT_PASSWORD = 'recoverForgotPassword',
  REGISTRATION_CELLPHONE = 'registrationCellphone'
}

export enum InvestorProfile {
  lowRisk = 'lowRisk',
  moderateRisk = 'moderateRisk',
  highRisk = 'highRisk'
}

export enum InvestorQuestionType {
  howMuchInvest = 'howMuchInvest',
  investedMethods = 'investedMethods',
  highRiskInvestment = 'highRiskInvestment',
  monthlyIncome = 'monthlyIncome',
  percentageOfMonthlyInvestment = 'percentageOfMonthlyInvestment',
  yourRescues = 'yourRescues',
  whatYourPrioritizes = 'whatYourPrioritizes',
  riskXReturn = 'riskXReturn',
  marketOscillations = 'marketOscillations',
  investmentApplications = 'investmentApplications',
  experienceOnFinancialMarket = 'experienceOnFinancialMarket'
}
